import {
  colors_default
} from "./chunk-FQ63V624.mjs";
import {
  font_sizes_default
} from "./chunk-DC6FLAW3.mjs";
import {
  line_heights_default
} from "./chunk-C6NNPMXG.mjs";
import {
  radius_default
} from "./chunk-6DLECL6B.mjs";
import {
  shadows_default
} from "./chunk-XYLMCSST.mjs";

// src/theme-provider/foundations/index.ts
var DEFAULT_THEME = { colors: colors_default, fontSizes: font_sizes_default, lineHeights: line_heights_default, shadows: shadows_default, radius: radius_default };

export {
  DEFAULT_THEME
};
